"use strict";

exports.__esModule = true;
exports.createAiDraftsStore = createAiDraftsStore;
var _normalizeAiDocument = require("./normalizeAiDocument");
var PREFIX = "vi.aiDrafts";

/**
 * Documents the AI produced (dashboards or reports), kept in this browser per
 * plant until svc-ui-config accepts them. Each entry wraps the document with
 * the time it was saved, so the document itself stays what the backend will
 * take later. Every document passes through `normalizeAiDocument` on the way
 * in and out, so a draft saved before a fix is repaired on its next read.
 * Falls back to memory when storage is blocked.
 */
function createAiDraftsStore(plantName, kind, storage) {
  if (storage === void 0) {
    storage = typeof window !== "undefined" ? window.localStorage : null;
  }
  var key = PREFIX + "." + (plantName || "plant") + "." + kind;
  var memory = {};
  var load = function load() {
    try {
      var raw = storage && storage.getItem(key);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return memory;
    }
  };
  var save = function save(entries) {
    memory = entries;
    try {
      storage && storage.setItem(key, JSON.stringify(entries));
    } catch (e) {
      // Private mode or blocked storage: the drafts last for this session.
    }
  };
  var idOf = function idOf(id) {
    return String(id);
  };
  var documentOf = function documentOf(entry) {
    return (0, _normalizeAiDocument.normalizeAiDocument)(entry.document);
  };
  return {
    key: key,
    list: function list() {
      return Object.values(load()).map(documentOf);
    },
    entries: function entries() {
      return load();
    },
    get: function get(id) {
      var entry = load()[idOf(id)];
      return entry ? documentOf(entry) : undefined;
    },
    has: function has(id) {
      return Object.prototype.hasOwnProperty.call(load(), idOf(id));
    },
    set: function set(input) {
      var document = (0, _normalizeAiDocument.normalizeAiDocument)(input);
      var entries = load();
      entries[idOf(document.id)] = {
        document: document,
        savedAt: new Date().toISOString()
      };
      save(entries);
      return document;
    },
    remove: function remove(id) {
      var entries = load();
      delete entries[idOf(id)];
      save(entries);
    },
    clear: function clear() {
      return save({});
    }
  };
}